<template>
 <div style="width:100%;height: 100%;">
   <div id="map" style="width:100%;height: 100%;">

   </div>
 </div>
</template>
<script>
import Vue from 'vue'
import { GPS } from '@/libs/positonUtils'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
function isNanDef (num, def, fix) {
  return (isNaN(num) ? def : num).toFixed(fix)
}
export default {
  name: 'bdmap',
  props: {
    locateHistorys: {
      required: true
    },
    trips: {
      required: true
    },
  },
  components: {
  },
  data () {
    return {
      BDmap:null,

      marker: null,

      locateHistorys:null,
      trips:null,
    }
  },
  methods: {
    creatmap() {
      var map = new BMapGL.Map('map'); // 创建Map实例
      this.BDmap = map
      var point = new BMapGL.Point(113.371431, 22.535336); // 创建点坐标
      map.centerAndZoom(point, 9);
      map.enableScrollWheelZoom(); // 启用滚轮放大缩小
      var navi3DCtrl = new BMapGL.NavigationControl3D({
        // 控件的停靠位置（可选，默认左上角）
        anchor: BMAP_ANCHOR_TOP_LEFT,
        // 控件基于停靠位置的偏移量（可选）
        // offset: new BMapGL.Size(10, 5)
      });  // 添加3D控件
      map.addControl(navi3DCtrl);


//       // 创建小车图标
//       var myIcon = new BMapGL.Icon(require("../../../../../public/vehiclerun.png"), new BMapGL.Size(24, 52),{imageSize:new BMapGL.Size(16, 33)});
// // 创建Marker标注，使用小车图标
//       var pt = new BMapGL.Point(113.371431, 22.535336);
//       var marker = new BMapGL.Marker(pt, {
//         icon: myIcon
//       });
//
//       this.marker = marker
//
//       this.BDmap.addOverlay(this.marker);
    },

    draw(locateHistorys,trips){
      // console.log(locateHistorys)
      // console.log(trips)


      this.BDmap.clearOverlays()
      locateHistorys.forEach(item => {
        let gcpoi =  GPS.gcj_encrypt(item.latitude,item.longitude)
        let bdpoi = GPS.bd_encrypt(gcpoi.lat,gcpoi.lon)
        item.latitude = bdpoi.lat
        item.longitude = bdpoi.lon
      })
      trips.forEach(item => {
        if (item.startLat != null) {
        let startgcpoi = GPS.gcj_encrypt(item.startLat, item.startLon)
        let startbdpoi = GPS.bd_encrypt(startgcpoi.lat, startgcpoi.lon)
        item.startLat = startbdpoi.lat
        item.startLon = startbdpoi.lon
      }

        if (item.endLat != null) {
          let endgcpoi = GPS.gcj_encrypt(item.endLat, item.endLon)
          let endbdpoi = GPS.bd_encrypt(endgcpoi.lat, endgcpoi.lon)
          item.endLat = endbdpoi.lat
          item.endLon = endbdpoi.lon
        }
      })
      this.drawMarker(trips)
      this.drawLine(locateHistorys)
    },
    /**
     * 绘制车辆停车点
     */
    async drawMarker(trips) {
      var point = []
      let count = -1
      await trips.forEach((item, index) => {
        /**
         * tripType为1是停车点
         */
        if (item.tripType === 0) {
          count = count + 1
          let imagecount = count + 1
          var myIcon = new BMapGL.Icon('/pois/poi_' + imagecount + '.png', new BMapGL.Size(19, 31));
          point.push(new BMapGL.Point(item.startLon, item.startLat),)
          var pt = new BMapGL.Point(item.startLon, item.startLat)
          var stopmarker = new BMapGL.Marker(pt, {
            icon: myIcon,
            id: index,
            offset: new BMapGL.Size(0, -16)
          });
          this.BDmap.addOverlay(stopmarker);
        }
      })

    },

    /**
     * 绘制车辆行驶轨迹路线
     */
    drawLine(locateHistorys){
      //
      // // 绘制线
      // var p = []
      // p.push(new BMapGL.Point(113.399, 22.910),
      //   new BMapGL.Point(113.405, 22.920),
      //   new BMapGL.Point(113.423493, 22.907445),
      //   new BMapGL.Point(113.723493, 22.57445),
      //   new BMapGL.Point(113.423493, 22.47445),
      //   new BMapGL.Point(113.210896, 22.61885),
      // )
      //
      // var polyl = new BMapGL.Polyline(
      //   p
      //   , {
      //     strokeColor: 'blue',
      //     strokeWeight: 10,
      //     strokeOpacity: 0.5
      //   });
      // this.BDmap.addOverlay(polyl);


// console.log('map'+locateHistorys)
      var point = []
      locateHistorys.forEach(item => {
        point.push(new BMapGL.Point(item.longitude,item.latitude),)
      })
      var polyline = new BMapGL.Polyline(
        point
      , {
        strokeColor: 'green',
        strokeWeight: 3,
        strokeOpacity: 0.5
      });

      this.BDmap.addOverlay(polyline);

      var view = this.BDmap.getViewport(eval(point));
      var mapZoom = view.zoom;
      var centerPoint = view.center;
      console.log(view)
      console.log(mapZoom)
      console.log(centerPoint)
      this.BDmap.centerAndZoom(centerPoint,mapZoom);

      // var view1 = this.BDmap.getViewport(point);
      // var mapZoom1 = view1.zoom;
      // var centerPoint1 = view1.center;
      // console.log(view1)
      // console.log(mapZoom1)
      // console.log(centerPoint1)
      // this.BDmap.centerAndZoom(centerPoint1,mapZoom1);
    },
    clear(){
      this.marker = null
      this.BDmap.clearOverlays()
    },
    drawCar (data) {
      console.log(data.latitude)
      // let gcpoi =  GPS.gcj_encrypt(data.latitude,data.longitude)
      // let bdpoi = GPS.bd_encrypt(data.latitude,data.longitude)
      // data.latitude = bdpoi.lat
      // data.longitude = bdpoi.lon
      // console.log(data.latitude)

      console.log('this.marker')
      console.log(this.marker)

      if (this.marker != null) {
        // this.BDmap.removeOverlay(this.marker)
        this.marker.setPosition(new BMapGL.Point(data.longitude, data.latitude))
        this.marker.setRotation(data.directionNum)
      }else {

        // 创建小车图标
        var myIcon = new BMapGL.Icon(require("../../../../../public/vehiclerun.png"), new BMapGL.Size(24, 52), {imageSize: new BMapGL.Size(16, 33)});
// 创建Marker标注，使用小车图标
        var pt = new BMapGL.Point(data.longitude, data.latitude);
        var marker = new BMapGL.Marker(pt, {
          icon: myIcon,
          rotation:data.directionNum,
          offset: new BMapGL.Size(6, 13)
        });

        this.marker = marker

        this.BDmap.addOverlay(this.marker);
      }
    },
    toStopLocation(data){
      this.BDmap.setCenter(new BMapGL.Point(data.Lon, data.Lat))
    },
  },
  computed: {
    _locateHistorys: {
      get () {
        return this.locateHistorys
      },

      set (val) {
        // this.$emit('input', val)
        // this.$emit('change', val)
      }
    },
    _trips: {
      get () {
        return this.trips
      },

      set (val) {
        // this.$emit('input', val)
        // this.$emit('change', val)
      }
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.creatmap()
      // this.drawLine()
    })
  }
}
</script>
<style lang="less">

</style>
